import { Button } from "../../../../../design/button";
import { Field, Label } from "../../../../../design/fieldset";
import OnboardingContainer from "../../../components/OnboardingContainer";
import { Input } from "../../../../../design/input";
import { Intake } from "../../../../../models/Intake";

const OnboardingSpouseStep: React.FC<{
  formData: Omit<
    Intake,
    "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy" | "status"
  >;
  setFormData: React.Dispatch<
    React.SetStateAction<
      Omit<
        Intake,
        "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy" | "status"
      >
    >
  >;
  onBack: () => void;
  onStepComplete: () => void;
}> = ({ onBack, onStepComplete, formData, setFormData }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onStepComplete();
  };

  return (
    <OnboardingContainer title={"Your Spouse"}>
      <>
        <p className="mb-6 text-gray-700">
          Please provide some information about your spouse. This will help us
          understand your situation better.
        </p>
        <form onSubmit={handleSubmit} className="space-y-6">
          <Field>
            <Label>Spouse's Name:</Label>
            <Input
              type="text"
              placeholder="Your Spouse's Name"
              className="w-full"
              value={formData.spouse.name}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  spouse: { ...formData.spouse, name: e.target.value },
                })
              }
              required
            />
          </Field>
          <Field>
            <Label>Spouses Date of Birth:</Label>
            <Input
              type="date"
              placeholder="Your Spouse's Date of Birth"
              className="w-full"
              value={
                formData.spouse.dateOfBirth
                  ? formData.spouse.dateOfBirth.toISOString().split("T")[0]
                  : ""
              }
              onChange={(e) =>
                setFormData({
                  ...formData,
                  spouse: {
                    ...formData.spouse,
                    dateOfBirth: e.target.value
                      ? new Date(e.target.value)
                      : null,
                  },
                })
              }
              required
            />
          </Field>
          <Button
            type="submit"
            className="w-full"
            disabled={!formData.spouse.name || !formData.spouse.dateOfBirth}
            onClick={handleSubmit}
          >
            Continue
          </Button>
        </form>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingSpouseStep;
